import { BaseQuestionEditComponent } from '../../../bases';
import { jsx as _jsx } from "react/jsx-runtime";
export var EssayEditComponent = function EssayEditComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;
  return /*#__PURE__*/_jsx(BaseQuestionEditComponent, {
    states: states,
    actions: actions
  });
};